import React from 'react';
import TabBar from '../kuroco/TabBar';
import { HomeBar, SettingsBtn } from '../kuroco/AppBars';

/**
 * KUROCO mobile app shell — column layout with HomeBar, scroll body, bottom TabBar.
 * Replaces Sidebar + TopBar in Phase 1 (legacy layout files kept intact).
 */
export default function AppShell({
  activeTab,
  onTabChange,
  displayName,
  settingsPath,
  showAdminTab,
  showCommentsTab = false,
  showStoresTab = false,
  pendingCount = 0,
  pageTitle,
  hideHomeBar = false,
  hideTabBar = false,
  children,
}) {
  const aiMode = activeTab === 'ai';
  return (
    <div
      className={`kuroco-shell app${aiMode ? ' ai-mode' : ''}`}
    >
      {!hideHomeBar &&
        (pageTitle ? (
          <header className="appbar appbar--plain">
            <div className="appbar-row">
              <div className="appbar-title">{pageTitle}</div>
              <div style={{ flex: '0 0 auto', display: 'flex', justifyContent: 'flex-end' }}>
                <SettingsBtn to={settingsPath} />
              </div>
            </div>
          </header>
        ) : (
          <HomeBar name={displayName} settingsPath={settingsPath} />
        ))}
      <main className="scroll">{children}</main>
      {!hideTabBar && (
        <TabBar
          active={activeTab}
          onChange={onTabChange}
          showAdmin={showAdminTab}
          showComments={showCommentsTab}
          showStores={showStoresTab}
          pendingCount={pendingCount}
        />
      )}
    </div>
  );
}
